import clsx from 'clsx'

import { Text } from '@wartek-id/text'

import type { FC } from 'react'

interface DataBlockProps {
  label: string
  children: any
  direction?: 'vertical' | 'horizontal'
  isError?: boolean
  errorMessage?: string
}

const DataBlock: FC<DataBlockProps> = ({
  label,
  children,
  direction = 'vertical',
  isError = false,
  errorMessage = '',
}) => {
  return (
    <div
      className={clsx({
        flex: true,
        'flex-col space-y-1': direction === 'vertical',
        'flex-row space-x-2': direction === 'horizontal',
      })}
    >
      <Text variant="body-sm" color="subdued" className="basis-2/5 shrink-0">
        {label}
      </Text>
      <div>
        {!!children && (
          <Text
            variant="body-sm"
            color={isError ? 'critical' : 'default'}
            className="basis-3/5 text-clip overflow-hidden"
            data-testid={`data-block-value-${label}`}
          >
            {children}
          </Text>
        )}
        {!!errorMessage && (
          <Text
            variant="body-sm"
            color="critical"
            data-testid={`data-block-error-${label}`}
          >
            {errorMessage}
          </Text>
        )}
      </div>
    </div>
  )
}
export default DataBlock
